// useReprovaDfdModal.js
import { useState } from 'react';

const useReprovaDfdModal = () => {
    const [setReprovaDfdModal, setModalProps] = useState({
        isOpen: false,
        dfd: null,
        onSuccess: () => {}
    });

    const showReprovaDfdModal = (dfd, onSuccess) => {
        setModalProps({
            isOpen: true,
            dfd,
            onSuccess
        });
    };

    const closeReprovaDfdModal = () => {
        setModalProps(prev => ({
            ...prev,
            isOpen: false
        }));
    };

    return {
        setReprovaDfdModal,
        showReprovaDfdModal,
        closeReprovaDfdModal
    };
};

export default useReprovaDfdModal;